// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'fackbackend',
  API_SERVER: 'https://gypsee.in/gypsee',
  firebaseConfig: {
    apiKey: 'AIzaSyA83wstrP6YTDuF7Lqs6wPmR5gQRayIuf4',
    authDomain: 'gypsee-c67a5.firebaseapp.com',
    databaseURL: 'https://gypsee-c67a5.firebaseio.com',
    projectId: 'gypsee-c67a5',
    storageBucket: 'gypsee-c67a5.appspot.com',
    messagingSenderId: '301689040521',
    appId: '1:301689040521:web:28b0321e0a4333b1d16058'
  },
  cloudinary: {
    apiKey: '183685532154895',
    apiSecret: 'ydglOJ4dXxdaJilpbTrU2oTW9vU',
    userImageUploadPreset: 'user-images',
    cloudName: 'gypsee-ai'
  },
  API_RAZOR_PAY_IFSC: 'https://ifsc.razorpay.com',
  SOCKET_SERVER_URL: 'https://gypsee.in/gypsee-microservices'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
